import React, { Component } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import LinkRoutes from "../constants/LinkRoutes";
import App from "../app/App";
import CookieConsent, { Cookies } from "react-cookie-consent";
import FrequencyQuestions from "../views/frequency-questions/FrequencyQuestions";
import RatesAndFees from "../views/rates-and-fees/RatesAndFees";
import { Button, Modal } from "react-bootstrap";
import Safe from "../views/safe/Safe"

import About from "../views/about/About";
import PromotionHistory from "views/promotion-history/PromotionHistory";
import Channels from "views/channels/Channels";
import Payments from "../views/payments/Payments";

import Contact from "views/contact/Contact";
import DigitalChannelSurgir from "views/digital-channel-surgir/DigitalChannelSurgir";
import Transparency from 'views/transparency/Transparency';



import WhereWeAre from "views/where-we-are/WhereWeAre";
import ComplaintsBook from "views/complaints-book/ComplaintsBook";
import FormComplaintsBook from "views/form-complaints-book/FormComplaintsBook"


import FooterSurgir from "layouts/FooterSurgir/FooterSurgir";


import SurgirNavbar from "layouts/navbar/rcf/Navbar";
export default class AdminRoutes extends Component {
  state = {
    modalVisible: false,
    cookiesVisible: true,
    searchContainer: false
  }
  changeVisibleModal = (value: any) => {
    this.setState({ modalVisible: value })
  }


  goTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    })
  }

  render() {
    return (
      <div className="position-relative">
        <SurgirNavbar onShowSearch={() => {
          this.setState({ searchContainer: !this.state.searchContainer })
        }} />

        <BrowserRouter>
          <Routes>
            <Route path={LinkRoutes.app} element={<App />} />
            <Route path="/*" element={<Navigate to={LinkRoutes.app} />} />
            <Route path={LinkRoutes.promotionHistory} element={<PromotionHistory />} />
            <Route path={LinkRoutes.transparency} element={<Transparency />} />
            <Route path={LinkRoutes.complaintsBook} element={<ComplaintsBook />} />
            <Route path={LinkRoutes.complaintsBook + '/formulario'} element={<FormComplaintsBook />} />
            <Route path={LinkRoutes.whereWeAre} element={<WhereWeAre />} />
            <Route path={LinkRoutes.channels} element={<Channels />} />
            <Route path={LinkRoutes.faqs} element={<FrequencyQuestions />} />
            <Route path={LinkRoutes.aboutUs} element={<About />} />
            <Route path={LinkRoutes.safe} element={<Safe />} />
            <Route path={LinkRoutes.contact} element={<Contact />} />
            <Route path={LinkRoutes.digitalChannelSurgir} element={<DigitalChannelSurgir />} />
                <Route path={LinkRoutes.payments} element={<Payments />} />

            <Route path={LinkRoutes.ratesAndFees} element={<RatesAndFees />} />
          </Routes>
          {this.state.cookiesVisible && <CookieConsent
            location="bottom"
            style={{ display: 'block', background: '#f5f9fb', textAlign: "left", color: "#000", padding: "20px" }}
            buttonStyle={{ color: "#fff", background: "#ec0000", fontSize: "14px", padding: "10px" }}
            buttonText="ACEPTAR TODAS LAS COOKIES"
            expires={365}
            cookieSecurity={true}
          >
            <div>
              <span className="cookies-title"> CONFIGURACIÓN DE COOKIES </span>
              <span>
                <br />
                En Santander Fondos Colectivos utilizamos cookies propias y de terceros que permiten la navegación óptima y el acceso a áreas seguras de la página web. Sin ellas, la página web no podrá funcionar adecuadamente. Estas cookies no almacenan ninguna información de identificación personal. Para más información consulta nuestra <a style={{ textDecoration: 'none', color: '#ec0000' }} href="/transparencia"> Política de Cookies</a>
              </span>
            </div>
            {/*  <Button onClick={() => this.changeVisibleModal(true)} variant='outline-danger' style={{ width: 209, paddingLeft: 16, paddingRight: 16, borderRadius: 0, marginTop: 12, marginBottom: -17 }}>
              CONNFIGURAR COOKIES 
            </Button> */}
          </CookieConsent>}
          <Modal show={this.state.modalVisible} onHide={() => this.changeVisibleModal(false)}>
            <Modal.Header closeButton >
              <Modal.Title>Configurar cookies:
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <li style={{ listStyle: 'none', verticalAlign: 'middle' }}>
                <label htmlFor="cbox1">
                  <input type="checkbox" disabled={true} checked={true} style={{ height: 16, width: 16, marginBottom: -20 }} />
                  <a style={{ fontFamily: 'SantanderTextW05-Bold', color: '#000000' }} > Cookies funcionales:</a> Son las que permiten la navegación óptima y el acceso a áreas seguras de la página web, por
                  lo cual la página web no podrá funcionar adecuadamente sin estas cookies. Estas cookies no alamacenan ninguna información
                  de identificación personal.</label>
              </li>
              <li style={{ listStyle: 'none', verticalAlign: 'middle' }}>
                <label htmlFor="cbox2">
                  <input type="checkbox" id="cbox2" value="second_checkbox" style={{ height: 16, width: 16 }} />
                  <a style={{ fontFamily: 'SantanderTextW05-Bold', color: '#000000' }} > Cookies analítica y optimización: </a>Son aquellas que permiten el editor de estas, el seguimiento y análisis del comportamiento
                  de los usuarios de los sitios web a los que están vinculados. La información recogida mediantes este tipo de cookies se utiliza en la medición
                  de la actividad de los sitios web, aplicación o plataforma, y para la elaboración de perfiles de navegación, con el fin de introducir
                  mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</label>
                <p>Puede consultar nuestra política de cookies en cualquier momento aquí o en la web </p>
              </li>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={() => {
                this.changeVisibleModal(false);
                this.setState({
                  cookiesVisible: false
                })
                Cookies.set('CookieConsent', true, { path: '/', secure: true });
              }
              } style={{ color: "#fff", background: "#ec0000", fontSize: "14px", padding: "10px", border: "2px" }} variant="primary">GUARDAR Y ACEPTAR</Button>

            </Modal.Footer>
          </Modal>
        </BrowserRouter>

        {/* <FooterRCC /> */}
        <FooterSurgir backTop={this.goTop}></FooterSurgir>
      </div>

    );
  }
}
